import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-header-title" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "profile-section" }
const _hoisted_4 = { class: "field-row" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "field-row" }
const _hoisted_7 = { class: "field-row" }
const _hoisted_8 = { class: "field-row" }
const _hoisted_9 = { class: "field-actions" }
const _hoisted_10 = { class: "profile-section" }
const _hoisted_11 = { class: "field-row" }
const _hoisted_12 = { class: "field-row" }
const _hoisted_13 = { class: "field-row" }
const _hoisted_14 = { class: "field-actions" }

import { reactive, ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { userApi } from '@/services/api';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileDialog',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const currentUser = computed(() => store.getters.currentUser);
const userIdx = computed(() => Number(currentUser.value?.idx || 0));

const loading = ref(false);
const savingProfile = ref(false);
const savingPassword = ref(false);

const form = reactive({
  u_id: '',
  u_name: '',
  u_email: '',
  u_phone: '',
});

const pwForm = reactive({
  oldPw: '',
  newPw: '',
  newPwConfirm: '',
});

const emitClose = (val: boolean) => {
  if (savingProfile.value || savingPassword.value) return;
  emit('update:modelValue', val);
};

const resetPasswordForm = () => {
  pwForm.oldPw = '';
  pwForm.newPw = '';
  pwForm.newPwConfirm = '';
};

const loadProfile = async () => {
  if (!userIdx.value) return;
  loading.value = true;
  try {
    const res = await userApi.getById(userIdx.value);
    if (res.data?.success && res.data.data) {
      const u = res.data.data;
      form.u_id = u.u_id || currentUser.value?.id || '';
      form.u_name = u.u_name || '';
      form.u_email = u.u_email || '';
      form.u_phone = u.u_phone || '';
    } else {
      form.u_id = currentUser.value?.id || '';
      form.u_name = currentUser.value?.name || '';
      form.u_email = currentUser.value?.email || '';
      form.u_phone = currentUser.value?.phone || '';
    }
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    form.u_id = currentUser.value?.id || '';
    form.u_name = currentUser.value?.name || '';
    form.u_email = currentUser.value?.email || '';
    form.u_phone = currentUser.value?.phone || '';
    const message = error?.response?.data?.message || error?.message || '불러오기 실패';
    store.dispatch('showError', `내 정보 조회 실패: ${message}`);
  } finally {
    loading.value = false;
  }
};

const saveProfile = async () => {
  if (!userIdx.value) return;
  if (!form.u_name.trim()) {
    store.dispatch('showError', '이름을 입력해주세요.');
    return;
  }
  savingProfile.value = true;
  try {
    await userApi.update(userIdx.value, {
      u_name: form.u_name.trim(),
      u_email: form.u_email.trim(),
      u_phone: form.u_phone.trim(),
    });
    store.dispatch('updateCurrentUserProfile', {
      name: form.u_name.trim(),
      email: form.u_email.trim(),
      phone: form.u_phone.trim(),
    });
    store.dispatch('showSuccess', '정보가 저장되었습니다.');
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    const message = error?.response?.data?.message || error?.message || '저장 실패';
    store.dispatch('showError', `정보 저장 실패: ${message}`);
  } finally {
    savingProfile.value = false;
  }
};

const savePassword = async () => {
  if (!userIdx.value) return;
  if (!pwForm.oldPw || !pwForm.newPw) {
    store.dispatch('showError', '현재 비밀번호와 새 비밀번호를 입력해주세요.');
    return;
  }
  if (pwForm.newPw.length < 4) {
    store.dispatch('showError', '새 비밀번호는 4자 이상이어야 합니다.');
    return;
  }
  if (pwForm.newPw !== pwForm.newPwConfirm) {
    store.dispatch('showError', '새 비밀번호 확인이 일치하지 않습니다.');
    return;
  }
  if (pwForm.oldPw === pwForm.newPw) {
    store.dispatch('showError', '새 비밀번호는 현재 비밀번호와 달라야 합니다.');
    return;
  }

  savingPassword.value = true;
  try {
    const res = await userApi.changePassword(userIdx.value, pwForm.oldPw, pwForm.newPw);
    if (res.data?.success === false) {
      store.dispatch('showError', res.data.message || '비밀번호 변경에 실패했습니다.');
      return;
    }
    store.dispatch('showSuccess', '비밀번호가 변경되었습니다.');
    resetPasswordForm();
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    const message = error?.response?.data?.message || error?.message || '변경 실패';
    store.dispatch('showError', `비밀번호 변경 실패: ${message}`);
  } finally {
    savingPassword.value = false;
  }
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      resetPasswordForm();
      loadProfile();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "480px",
    persistent: "",
    "onUpdate:modelValue": emitClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "user-profile-dialog" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "dialog-header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-account-cog-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" 내 정보 ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "dialog-close",
                "aria-label": "닫기",
                disabled: savingProfile.value || savingPassword.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emitClose(false)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "profile-body" }, {
            default: _withCtx(() => [
              _createVNode(LoadingOverlay, {
                show: savingProfile.value || savingPassword.value || loading.value,
                text: savingPassword.value ? '비밀번호 변경 중...' : savingProfile.value ? '저장 중...' : '불러오는 중...'
              }, null, 8, ["show", "text"]),
              _createElementVNode("section", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "section-title" }, "기본 정보", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "field-label" }, "아이디", -1)),
                  _createElementVNode("input", {
                    class: "native-input disabled",
                    type: "text",
                    value: form.u_id,
                    disabled: ""
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "field-label" }, "이름 *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.u_name) = $event)),
                    class: "native-input",
                    type: "text",
                    placeholder: "이름"
                  }, null, 512), [
                    [_vModelText, form.u_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "field-label" }, "이메일", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.u_email) = $event)),
                    class: "native-input",
                    type: "email",
                    placeholder: "email@example.com"
                  }, null, 512), [
                    [_vModelText, form.u_email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "field-label" }, "연락처", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.u_phone) = $event)),
                    class: "native-input",
                    type: "tel",
                    placeholder: "010-0000-0000"
                  }, null, 512), [
                    [_vModelText, form.u_phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-save",
                    loading: savingProfile.value,
                    disabled: loading.value || savingPassword.value,
                    onClick: saveProfile
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" 정보 저장 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ]),
              _createElementVNode("section", _hoisted_10, [
                _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "section-title" }, "비밀번호 변경", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "field-label" }, "현재 비밀번호 *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pwForm.oldPw) = $event)),
                    class: "native-input",
                    type: "password",
                    autocomplete: "current-password",
                    placeholder: "현재 비밀번호"
                  }, null, 512), [
                    [_vModelText, pwForm.oldPw]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "field-label" }, "새 비밀번호 *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pwForm.newPw) = $event)),
                    class: "native-input",
                    type: "password",
                    autocomplete: "new-password",
                    placeholder: "새 비밀번호 (4자 이상)"
                  }, null, 512), [
                    [_vModelText, pwForm.newPw]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "field-label" }, "새 비밀번호 확인 *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((pwForm.newPwConfirm) = $event)),
                    class: "native-input",
                    type: "password",
                    autocomplete: "new-password",
                    placeholder: "새 비밀번호 다시 입력"
                  }, null, 512), [
                    [_vModelText, pwForm.newPwConfirm]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-edit",
                    loading: savingPassword.value,
                    disabled: loading.value || savingProfile.value,
                    onClick: savePassword
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" 비밀번호 변경 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "btn-close",
                disabled: savingProfile.value || savingPassword.value,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (emitClose(false)))
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode(" 닫기 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})